export const SUPER_ADMIN = "super_admin";
export const SERVICE_PROVIDER = "service_provider";

export const DEBOUNCED_WAIT_TIME = 500;

// This is the debounced wait time for the brand search input
export const BRAND_SEARCH_DEBOUNCED_WAIT_TIME = 250;
